"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../Schema/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const BulkEditorField = props => {
  const schema = props.schema,
        uiSchema = props.uiSchema,
        formData = props.formData,
        formContext = props.formContext,
        registry = props.registry;
  const primaryAction = formContext.primaryAction,
        secondaryAction = formContext.secondaryAction,
        preview = formContext.preview,
        untitled = formContext.untitled,
        title = formContext.title,
        languages = formContext.languages,
        currentLocale = formContext.currentLocale,
        onLocale = formContext.onLocale,
        onClose = formContext.onClose;

  const newUiSchema = _extends({}, uiSchema, {
    "ui:id": "editor",
    "ui:preview": preview,
    "ui:untitled": untitled,
    "ui:title": title,
    "ui:primaryAction": primaryAction,
    "ui:secondaryAction": secondaryAction,
    "ui:languages": languages,
    "ui:currentLocale": currentLocale,
    "ui:onLocale": onLocale,
    "ui:onClose": onClose,
    "ui:layout": "bulkEditor"
  });

  const ObjectField = registry.fields.ObjectField;
  return _react.default.createElement(ObjectField, _extends({}, props, {
    uiSchema: newUiSchema
  }));
};

var _default = BulkEditorField;
exports.default = _default;
module.exports = exports.default;